import React, { Component, useState, useRef, useCallback, useEffect } from 'react'
import { useMount } from 'react-use'
import ReactImageFallback from "react-image-fallback"
import { Spin, Upload, Button, message, Popconfirm, Empty } from 'antd'
import { Icon } from 'antd'
import styles from './assetsManager.module.scss'
import debounce from 'lodash/debounce'
import dayjs from 'dayjs'
import * as apis from '@/apis'

export default function AssetsManager(props) {
  const [loading, setLoading] = useState(false)
  const [assets, setFileList] = useState([])
  // const onUploadStart = useCallback(file => {

    // this.setState({ loading: true })
  // }, [])

  const customRequest = useCallback(({ file, onSuccess }) => {
    setLoading(true)
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'company-material')

    apis.uploadFile(formData).then(response => {
      const asset = {
        id: Math.random().toString(36).slice(-8),
        name: file.name,
        url: response.url,
        file: response._id,
        type: file.type,
        createdAt: new Date()
      }
      const list = [...assets, asset]

      return apis.updateTenantAssets(props.tenant._id, list)
        .then(() => {
          setFileList(list)
          onSuccess(response)

          return list
        })
    }).then(() => {
      message.success('上传成功')
    }).catch(err => {
      message.error(err.message || '图片上传失败')
    }).finally(() => setLoading(false))

    return {
      abort() {
        console.log('upload progress is aborted.')
      },
    }
  }, [assets])

  const deleteItem = useCallback(id => {
    const list = assets.filter(item => item.id !== id)
    setLoading(true)
    apis.updateTenantAssets(props.tenant._id, list)
      .then(() => {
        setFileList(list)
        message.success('已删除')
      }).catch(err => {
        message.error(err.message || '删除失败')
      }).finally(() => setLoading(false))
  }, [assets])

  useEffect(() => {
    setLoading(true)
    apis.getTenantAssets(props.tenant._id)
      .then(({ assets }) => setFileList(assets))
      .finally(() => setLoading(false))
  }, [props.tenant._id])

  const uploadParams = {
    className: styles.upload,
    customRequest,
    showUploadList: false,
    accept: 'image/*'
  }

  return (
    <Spin spinning={loading}>
      <div>
        <div>
          <Upload {...uploadParams} disabled={assets.length>=20}>
            <Button type="primary" disabled={assets.length>=20}>
              <Icon type="upload" /> 上传
            </Button>
          </Upload>
          <span className={styles.uploadTips}>* 只能上传图片文件，最多限制上传20张图片</span>
        </div>
        <div className={styles.fileList}>
          {
            assets.length === 0 && (
              <Empty
                image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
                imageStyle={{
                  height: 120,
                }}
                className={styles.empty}
                description={
                  <div style={{fontSize: 12, paddingTop: 30}}>暂未上传任何资料</div>
                }>
              </Empty>
            )
          }
          {
            assets.map(asset => {
              return (
                <div className={styles.file} key={asset.id}>
                  <div className={styles.closeBtn}>
                    <Popconfirm
                      title="删除后不可恢复，确定要删除?"
                      onConfirm={() => deleteItem(asset.id)}>
                      <Icon type="close" className={styles.close} />
                    </Popconfirm>
                  </div>
                  {
                    (asset.type && /image/.test(asset.type)) ? (
                      <ReactImageFallback
                        className={styles.thumbnail}
                        src={asset.url + '?x-oss-process=image/resize,m_fill,h_100,w_100/format,webp'}
                        fallbackImage="http://xiaobingsubang.oss-cn-beijing.aliyuncs.com/company-material/001a3de16aa4b25c9fdc5de0d37d0f4b.svg" />
                      ) : (
                      <img
                        className={styles.thumbnail}
                        src="http://xiaobingsubang.oss-cn-beijing.aliyuncs.com/company-material/001a3de16aa4b25c9fdc5de0d37d0f4b.svg" />
                      )
                  }

                  <div className={styles.info}>
                    <a
                      target="_blank"
                      href={asset.url}
                      className={styles.name}>{ asset.name }</a>
                    <div className={styles.createdAt}>
                      上传于 { dayjs(asset.createdAt).format('YYYY-MM-DD HH:mm:ss') }
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </Spin>
  )


}
